import { useMutation, UseMutationOptions } from 'react-query';
import apiClient from 'src/queries/apiClient';
import { ApiResponseType, responseWrapper } from 'src/queries/helpers';

export function useCreateVendorRecord(
  options?: UseMutationOptions<ApiResponseType<any>, Error, any>
) {
  const {
    mutate: createVendorRecord,
    data,
    isLoading,
    isSuccess,
  } = useMutation<ApiResponseType<any>, Error, any>({
    mutationFn: (payload: any) => responseWrapper(apiClient.createVendorsRecord, [payload]),
    ...options,
  });

  return {
    createVendorRecord,
    data,
    isLoading,
    isSuccess,
  };
}
